import { render, staticRenderFns } from "./Case-Header.vue?vue&type=template&id=81dfd830"
import script from "./Case-Header.vue?vue&type=script&lang=js"
export * from "./Case-Header.vue?vue&type=script&lang=js"
import style0 from "./Case-Header.vue?vue&type=style&index=0&id=81dfd830&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports